import { cn } from '@gozoki/ui/lib/utils'
import closeIcon from '~/assets/dashboard/close.svg'

// Bouton de fermeture partagé des modales. Le visuel reste la pastille blanche 28px + croix 14px du
// Figma (le <span> interne) ; le bouton lui-même est transparent et élargit la zone tactile à 44px
// via p-[8px] -m-[8px] (cible doigt kiosk PCAP) sans décaler la pastille ni la mise en page (la
// marge négative annule le padding). Les modales sont montées hors du transform: scale, donc ces px
// sont les px écran réels : une pastille 28px seule serait sous la cible tactile.
export function ModalCloseButton({
  onClose,
  ariaLabel = 'Fermer',
  className,
}: {
  onClose: () => void
  ariaLabel?: string
  className?: string
}) {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label={ariaLabel}
      className={cn('shrink-0 cursor-pointer p-[8px] -m-[8px]', className)}
    >
      <span className="flex size-[28px] items-center justify-center rounded-[14px] border border-[#D7D7D7] bg-white">
        <img src={closeIcon} alt="" aria-hidden className="size-[14px]" />
      </span>
    </button>
  )
}
